import { gql } from '@apollo/client'
import CAREPLAN_DRAFT_FRAGMENT from 'apollo/fragments/CAREPLAN_DRAFT_FRAGMENT'
import { useSafeRunMutation } from 'utils/mutations'

// CREATE_CAREPLAN_ENTITY

const mutation = gql`
  mutation createRoadmapEntity(
    $entity_id: ID!
    $roadmap_id: ID!
    $entity_type: ROADMAP_ENTITY_SOURCE_TYPE!
    $attributes: RoadmapEntityAttributesInput! # $cost: Float
  ) {
    createRoadmapEntity(
      entity_id: $entity_id
      roadmap_id: $roadmap_id
      entity_type: $entity_type
      attributes: $attributes
    ) {
      ...CAREPLAN_DRAFT_FRAGMENT
    }
  }
  ${CAREPLAN_DRAFT_FRAGMENT}
`

export default function useCreateRoadmapEntity(
  successMessage = 'Provider/Facility added'
) {
  const { onMutate: onCreateRoadmapEntity, loading } = useSafeRunMutation({
    mutation,
    successMessage,
    responsePath: 'createRoadmapEntity'
  })
  return { onCreateRoadmapEntity, loading }
}
